import i18n from "i18next";
import HourglassGlobals from "../../helpers/globals";
import { NAV_ITEMS, NavItem } from "../nav/navRegistry";

export type PageContext = { pathname: string; routeKey: string; pageTitle: string; lang: string };

const idSegment = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

/** Strips the app basename and cuts the path at the first numeric/UUID segment, e.g. /monthSummary/2026/9 -> /monthSummary */
export function normalizeRoute(pathname: string, appBase: string = HourglassGlobals.AppBase): string {
  let path = pathname;
  if (appBase && (path === appBase || path.startsWith(appBase + "/"))) {
    path = path.slice(appBase.length);
  }
  const kept: string[] = [];
  for (const seg of path.split("/").filter(Boolean)) {
    if (idSegment.test(seg)) break;
    kept.push(seg);
  }
  return "/" + kept.join("/");
}

/** Label of the nav item whose path is the longest prefix of routeKey (ignores per-user visibility). */
function navTitle(routeKey: string): string {
  let best: NavItem | undefined;
  let bestLen = -1;
  for (const item of NAV_ITEMS) {
    if (!item.path || item.external) continue;
    const itemKey = normalizeRoute(item.path, "");
    const matches = routeKey === itemKey || routeKey.startsWith(itemKey + "/");
    if (matches && itemKey.length > bestLen && itemKey !== "/") {
      best = item;
      bestLen = itemKey.length;
    }
  }
  return best ? i18n.t(best.labelKey) : "";
}

export function buildPageContext(pathname: string): PageContext {
  const routeKey = normalizeRoute(pathname);
  return {
    pathname,
    routeKey,
    pageTitle: navTitle(routeKey) || (typeof document !== "undefined" ? document.title : ""),
    lang: i18n.language,
  };
}
